import { render, staticRenderFns } from "./pageList.vue?vue&type=template&id=5b03a795&scoped=true&"
import script from "./pageList.vue?vue&type=script&lang=js&"
export * from "./pageList.vue?vue&type=script&lang=js&"
import style0 from "./pageList.vue?vue&type=style&index=0&id=5b03a795&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b03a795",
  null
  
)

export default component.exports